import { cx } from "@emotion/css";
import { useTranslation } from "react-i18next";
import { PrimaryButton } from "src/components/Default/LekUI/Button";

interface FolderEmptyListViewProps {
	onClick: () => void;
	text?: string;
	title?: string;
	buttonText?: string;
}

export const FolderEmptyListView = ({
	onClick,
	text,
	title,
	buttonText,
}: FolderEmptyListViewProps) => {
	const { t } = useTranslation();

	return (
		<div
			className={cx(
				"flex flex-col items-center justify-center bg-white border-radius-24 p-32",
			)}
		>
			<h3 className="m-0 mb-12 size-20-bold text-center color-black">
				{title ?? t("folder.emptyList.title", "Czegoś tu brakuje...")}
			</h3>
			<p className="m-0 mb-24 size-16-light text-center color-black-60">
				{text ??
					t(
						"folder.emptyList.description",
						"Dodaj elementy do folderu, a wtedy pojawią się w tym miejscu",
					)}
			</p>
			<PrimaryButton
				onClick={onClick}
				className="flex items-center"
				data-test-id="folder-add-elements-button"
			>
				{buttonText ?? t("folder.emptyList.button", "Dodaj elementy")}
			</PrimaryButton>
		</div>
	);
};
